import { render, staticRenderFns } from "./Cells.vue?vue&type=template&id=51450d69&scoped=true&"
import script from "./Cells.vue?vue&type=script&lang=js&"
export * from "./Cells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51450d69",
  null
  
)

export default component.exports